const prodApiBasePath = `https://hhr.rzltech.com/hhr_eloan/`
const devApiBasePath = `http://test.rzltech.com/hhr_eloan/`
// const devApiBasePath = `http://192.168.0.108:18081/hhr_eloan/`
export default {
  basePath: '',
  apiBasePath: process.env.NODE_ENV === 'production' ? `${prodApiBasePath}` : `${devApiBasePath}`
}



// WEBPACK FOOTER //
// ./src/config/index.js